// extracted by mini-css-extract-plugin
export default {"switchContainer":"RolesAdminTable_switchContainer__V2u2N","rowContainer":"RolesAdminTable_rowContainer__9Md1l"};